import { requestImage, requestWithPromise } from '..'
import { HttpMethods } from '../apiHelper'
import { DATA_SHARING_TYPE } from '../entities/optin'
import apiClient from './apiClient'

export const createAssistant = (assistantData, user) => {
  return requestWithPromise(
    '/api/assistants',
    HttpMethods.POST,
    assistantData,
    user
  ).then(json => {
    if (json && json.data) {
      return json.data
    }
  })
}

export const getAllAssistants = user => apiClient.get(user, 'api/assistants')

export const getAssistant = (user, assistant, parameters = { details: ['specialities'] }) =>
  apiClient.get(user, `api/assistants/${assistant.id}`, parameters)

export const getAssistantProfileImage = (user, assistant) => {
  return requestImage(
    `/api/assistants/${user.assistant.id}/profile-image`,
    'GET',
    null,
    user
  )
}

export const getAssistantExtraInformations = (user, assistant) => apiClient.get(user, `api/assistants/${assistant.id}/extra-contact-info`)
export const updateAssistantExtraInformations = (user, assistant, body) => apiClient.post(user, `api/assistants/${assistant.id}/extra-contact-info`, body)

export const getAssistantOptin = (user, assistant, parameters = { type: DATA_SHARING_TYPE }) =>
  apiClient.get(user, `api/assistants/${assistant.id}/optin`, parameters)

export const getAssistantMaccsInternshipWithContexts = (user, assistant, parameters) => apiClient.get(user, `api/assistants/${assistant.id}/maccs-internships`, parameters)

export const updateAssistant = (assistant, body, user) => {
  return requestWithPromise(
    `/api/assistants/${assistant.id}`,
    HttpMethods.PATCH,
    body,
    user
  ).then(json => {
    if (json && json.data) {
      return json.data
    }
  })
}

export const exportMaccsInternshipsHistory = (assistant, language, user) => {
  return requestWithPromise(
    `/api/assistants/${assistant}/export-maccs-internships-history?language=${language}`,
    HttpMethods.GET,
    null,
    user
  ).then(json => {
    if (json) {
      return json
    }
  })
}
